import { useWorkspace } from 'wrappers/WorkspaceProvider';

import type { Permission } from '@fragment/authorization-utils';
import { ROLE_PERMISSIONS } from '@fragment/authorization-utils/rolePermissions';

export const useHasWorkspacePermission = (permission: Permission): boolean => {
  const { workspace } = useWorkspace();
  return workspace ? ROLE_PERMISSIONS[workspace.role].has(permission) : false;
};
